// extracted by mini-css-extract-plugin
export default {"item":"PropertyItem_item__4HcUd","rightColumn":"PropertyItem_rightColumn__bah35"};